
















































































import { Component, Prop, Vue, Provide, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class SearchBar extends Vue {
  @Prop() private category!: string;
  @Prop() private subcategory!: string;
  @Prop() private leaf!: string;
  @Prop() private query!: string;
  @Prop() private tab!: string;

  @Provide("$herculeApi") $herculeApi: any;
  @Provide("$api") $api: any;

  created() {
    if (this.$store.state.allCategories.length === 0) {
      this.$store.commit("startLoading");
      this.$api.get("api/categories/").then((result: any) => {
        this.$store.state.allCategories = result.data;
        this.$store.commit("stopLoading");
      });
    }
  }

  private _categorySelected: string | null = null;
  private userQuery: string = this.query || "";
  private taxCodesLoading = true;
  private taxcodesDict: any = {};
  allCategories: any;
  get categorySelected() {
    const { _categorySelected, category } = this;
    return _categorySelected || category || "";
  }
  set categorySelected(value) {
    this.$store.state.category = value;
    this._categorySelected = value;
    this.$router.push({
      name: "search_category",
      query: {
        q: this.query,
        category: value,
        tab: this.tab,
      },
    });
  }
  onSearch(event: any) {
    this.$router.push({
      name: "search_category",
      query: {
        q: this.userQuery,
        category: this.category,
        subcategory: this.subcategory,
        leaf: this.leaf,
        tab: this.tab,
      },
    });
  }
  get categories() {
    return [{ text: "All Categories", value: "" }].concat(
      this.$store.state.allCategories.map((x: any) => {
        return { text: x.name, value: x.name };
      })
    );
  }

  get downloadPath() {
    return (
      this.$store.getters.assetsPathGlobal + "/Avalara_goods_and_services.xlsx"
    );
  }

  get widget() {
    return this.$store.state.widget;
  }

  mounted() {
    this._categorySelected = this.category || "";
  }
}
